import { render, staticRenderFns } from "./floor.vue?vue&type=template&id=6b7a40b6&scoped=true"
import script from "./floor.vue?vue&type=script&lang=js"
export * from "./floor.vue?vue&type=script&lang=js"
import style0 from "./floor.vue?vue&type=style&index=0&id=6b7a40b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a40b6",
  null
  
)

export default component.exports